module.exports = __webpack_public_path__ + "static/media/testSteps.5bd816b8.gif";